import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/ptz/g5-ptz.png";
import type { Product } from "../../types";
import { ptz as productListGroupPTZ } from "../product-list-groups/ptz";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g5Ptz: Product = {
  id: "g5PTZ",
  productTitle: "G5 PTZ",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g5-ptz`,
  ],
  storePathParts: {
    productSlug: "uvc-g5-ptz",
    category: UniFiChildCategorySlug.CamerasPTZ,
  },
  sku: "UVC-G5-PTZ",
  description: "g5PTZ.customDescription",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListGroupPTZ,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "translation",
        value: "g5Ptz.dimensions",
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '5MP 1/2.7" CMOS' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g5PTZ.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "g5PTZ.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: {
        type: "translation",
        value: "g5PTZ.opticalZoom",
      },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.microphone" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
